import axios from 'axios';

async function getUserDetails() {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/user`);
  return data;
}

async function register(payload) {
  return axios.post(`${import.meta.env.VITE_API_URL}/api/user/register`, payload);
}

async function getUserCompanies() {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/user/companies`);
  return data;
}

async function addCompaniesToUser(companies) {
  const { data } = await axios.post(
    `${import.meta.env.VITE_API_URL}/api/user/companies/add`,
    {
      companyIds: companies,
    },
  );

  return data;
}

export {
  addCompaniesToUser,
  getUserCompanies,
  getUserDetails,
  register,
};